export default function isInvalidNotNegativeNumber(num) {
  return (!num && num !== 0) || Number.isNaN(Number(num)) || Number(num) < 0;
}
